<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <div class="headline font-weight-bold mb-4">
          Metricas Generales
        </div>
        <v-breadcrumbs
          divider=">"
          :items="breadcrumbItems"
          class="pa-0"
        ></v-breadcrumbs>
      </v-col>
    </v-row>
    <v-row>
      <!------------------------------------------------------------------->
      <!-- ACTIVE ORGANIZATIONS--------------------------------------------------->
      <!------------------------------------------------------------------->
      <v-col cols="12" sm="6" md="4">
        <v-card class="rounded-card cards" height="100%">
          <v-card-title
            class="subtitle-1 font-weight-medium grey--text text--darken-2"
            style="word-break: keep-all "
          >
            Organizaciones Activas
          </v-card-title>
          <v-divider />
          <v-card-text class="text-right">
            <span
              class="headline font-weight-medium primary--text text--darken-2"
            >
              {{ stats.activeOrganizations }}
            </span>
          </v-card-text>
        </v-card>
      </v-col>
      <!------------------------------------------------------------------->
      <!-- ORGANIZATIONS WITH AUTOMATION -------------------------------------------------->
      <!------------------------------------------------------------------->
      <v-col cols="12" sm="6" md="4">
        <v-card class="rounded-card cards" height="100%">
          <v-card-title
            class="subtitle-1 font-weight-medium grey--text text--darken-2"
            style="word-break: keep-all "
          >
            Organizaciones con automation
          </v-card-title>
          <v-divider />
          <v-card-text class="text-right">
            <span
              class="headline font-weight-medium primary--text text--darken-2"
            >
              {{ stats.organizationsWithAutomation }}
            </span>

            <span
              class="headline font-weight-medium primary--text text--lighten-2"
            >
              |
              {{
                parseFloat(
                  stats.organizationsWithAutomationPercentage * 100
                ).toFixed(2)
              }}
              %
            </span>
          </v-card-text>
        </v-card>
      </v-col>
      <!------------------------------------------------------------------->
      <!-- ORGANIZATIONS WITHOUT AUTOMATION -------------------------------------------------->
      <!------------------------------------------------------------------->
      <v-col cols="12" sm="6" md="4">
        <v-card class="rounded-card cards" height="100%">
          <v-card-title
            class="subtitle-1 font-weight-medium grey--text text--darken-2"
            style="word-break: keep-all "
          >
            Organizaciones sin automation
          </v-card-title>
          <v-divider />
          <v-card-text class="text-right">
            <span
              class="headline font-weight-medium primary--text text--darken-2"
            >
              {{ stats.organizationsWithoutAutomation }}
            </span>

            <span
              class="headline font-weight-medium primary--text text--lighten-2"
            >
              |
              {{
                parseFloat(
                  stats.organizationsWithoutAutomationPercentage * 100
                ).toFixed(2)
              }}
              %
            </span>
          </v-card-text>
        </v-card>
      </v-col>
      <!------------------------------------------------------------------->
      <!-- ORGANIZATIONS WITH RECURRENT PAYMENTS -------------------------------------------------->
      <!------------------------------------------------------------------->
      <v-col cols="12" sm="6" md="4">
        <v-card class="rounded-card cards" height="100%">
          <v-card-title
            class="subtitle-1 font-weight-medium grey--text text--darken-2"
            style="word-break: keep-all "
          >
            Organizaciones con Recurrent Payments
          </v-card-title>
          <v-divider />
          <v-card-text class="text-right">
            <span
              class="headline font-weight-medium primary--text text--darken-2"
            >
              {{ stats.OrganizationsWithRecurrentPayments }}
            </span>

            <span
              class="headline font-weight-medium primary--text text--lighten-2"
            >
              |
              {{
                parseFloat(
                  stats.OrganizationsWithRecurrentPaymentsPercentage * 100
                ).toFixed(2)
              }}
              %
            </span>
          </v-card-text>
        </v-card>
      </v-col>
      <!------------------------------------------------------------------->
      <!-- ORGANIZATIONS WITH TRANSACTIONS FOR MORE THAN 500USD -------------------------------------------------->
      <!------------------------------------------------------------------->
      <v-col cols="12" sm="6" md="4">
        <v-card class="rounded-card cards" height="100%">
          <v-card-title
            class="subtitle-1 font-weight-medium grey--text text--darken-2"
            style="word-break: keep-all "
          >
            Organizaciones con Transacciones mayores a 500USD
          </v-card-title>
          <v-divider />
          <v-card-text class="text-right">
            <span
              class="headline font-weight-medium primary--text text--darken-2"
            >
              {{ stats.organizationsWithTransactionsGreater }}
            </span>

            <span
              class="headline font-weight-medium primary--text text--lighten-2"
            >
              |
              {{
                parseFloat(
                  stats.organizationsWithTransactionsGreaterPercentage * 100
                ).toFixed(2)
              }}
              %
            </span>
          </v-card-text>
        </v-card>
      </v-col>
      <!------------------------------------------------------------------->
      <!-- ORGANIZATIONS WITH TRANSACTIONS FOR LESS THAN 500USD -------------------------------------------------->
      <!------------------------------------------------------------------->
      <v-col cols="12" sm="6" md="4">
        <v-card class="rounded-card cards" height="100%">
          <v-card-title
            class="subtitle-1 font-weight-medium grey--text text--darken-2"
            style="word-break: keep-all "
          >
            Organizaciones con Transacciones menores a 500USD
          </v-card-title>
          <v-divider />
          <v-card-text class="text-right">
            <span
              class="headline font-weight-medium primary--text text--darken-2"
            >
              {{ stats.organizationsWithTransactionsLessThan }}
            </span>

            <span
              class="headline font-weight-medium primary--text text--lighten-2"
            >
              |
              {{
                parseFloat(
                  stats.organizationsWithTransactionsLessThanPercentage * 100
                ).toFixed(2)
              }}
              %
            </span>
          </v-card-text>
        </v-card>
      </v-col>
      <!------------------------------------------------------------------->
      <!-- ORGANIZATIONS WITH NO TRANSACTIONS  -------------------------------------------------->
      <!------------------------------------------------------------------->
      <v-col cols="12" sm="6" md="4">
        <v-card class="rounded-card cards" height="100%">
          <v-card-title
            class="subtitle-1 font-weight-medium grey--text text--darken-2"
            style="word-break: keep-all "
          >
            Organizaciones sin Transacciones
          </v-card-title>
          <v-divider />
          <v-card-text class="text-right">
            <span
              class="headline font-weight-medium primary--text text--darken-2"
            >
              {{ stats.orgsWithNoTransactions }}
            </span>

            <span
              class="headline font-weight-medium primary--text text--lighten-2"
            >
              |
              {{
                parseFloat(
                  stats.orgsWithNoTransactionsPercentage * 100
                ).toFixed(2)
              }}
              %
            </span>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="isLoading" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          {{ $t("general.loading") }}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "ClientsGlobalStats",
  data() {
    return {
      isLoading: false,
      resetFilters: false,
      stats: {
        activeOrganizations: 0,
        organizationsWithAutomation: 0,
        organizationsWithAutomationPercentage: 0,
        organizationsWithoutAutomation: 0,
        organizationsWithoutAutomationPercentage: 0,
        organizationsWithTransactionsGreater: 0,
        organizationsWithTransactionsGreaterPercentage: 0,
        organizationsWithTransactionsLessThan: 0,
        organizationsWithTransactionsLessThanPercentage: 0,
        orgsWithNoTransactions: 0,
        OrganizationsWithRecurrentPayments: 0,
        OrganizationsWithRecurrentPaymentsPercentage: 0,
        orgsWithNoTransactionsPercentage: 0
      },
      breadcrumbItems: [
        {
          text: "Dashboard Clients",
          disabled: false
        },
        {
          text: "Metricas Generales",
          disabled: true,
          href: ""
        }
      ]
    };
  },
  async created() {
    await this.loadData();
  },
  computed: {
    ...mapGetters({
      clientsGlobalStats: "dashboardClients/clientsGlobalStats"
    })
  },
  methods: {
    ...mapActions({
      getClientsGlobalStats: "dashboardClients/getClientsGlobalStats"
    }),
    async loadData() {
      this.isLoading = true;
      await this.getClientsGlobalStats();
      this.isLoading = false;

      const {
        activeOrganizations,
        organizationsWithAutomation,
        organizationsWithAutomationPercentage,
        organizationsWithoutAutomation,
        organizationsWithoutAutomationPercentage,
        organizationsWithTransactionsGreater,
        organizationsWithTransactionsLessThan,
        orgsWithNoTransactions,
        orgsWithNoTransactionsPercentage,
        organizationsWithTransactionsGreaterPercentage,
        organizationsWithTransactionsLessThanPercentage,
        OrganizationsWithRecurrentPayments,
        OrganizationsWithRecurrentPaymentsPercentage
      } = this.clientsGlobalStats;

      this.stats = {
        activeOrganizations: activeOrganizations,
        organizationsWithAutomation: organizationsWithAutomation,
        organizationsWithAutomationPercentage: organizationsWithAutomationPercentage,
        organizationsWithoutAutomation: organizationsWithoutAutomation,
        organizationsWithoutAutomationPercentage: organizationsWithoutAutomationPercentage,
        organizationsWithTransactionsGreater: organizationsWithTransactionsGreater,
        organizationsWithTransactionsLessThan: organizationsWithTransactionsLessThan,
        orgsWithNoTransactions: orgsWithNoTransactions,
        orgsWithNoTransactionsPercentage: orgsWithNoTransactionsPercentage,
        organizationsWithTransactionsGreaterPercentage: organizationsWithTransactionsGreaterPercentage,
        organizationsWithTransactionsLessThanPercentage: organizationsWithTransactionsLessThanPercentage,
        OrganizationsWithRecurrentPayments: OrganizationsWithRecurrentPayments,
        OrganizationsWithRecurrentPaymentsPercentage: OrganizationsWithRecurrentPaymentsPercentage
      };
    }
  }
};
</script>
<style scoped>
.report-title {
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 30px;
  color: #344054;
}

.select-date-title {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #344054;
}

.input {
  box-sizing: border-box;
  padding: 10px 14px;
  gap: 8px;
  width: 223px;
  height: 44px;
  background: #ffffff;
  border: 1px solid #d0d5dd;
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
  border-radius: 8px;
  border: none;
}

.icon {
  width: 40px;
  height: 40px;
  border-radius: 28px;
  margin: 0px 4px 0px 0px;
}

.cards {
  border-radius: 12px;
}

.card-values {
  display: flex;
  justify-content: space-around;
}

.fixed {
  position: sticky;
  width: 5em;
  left: 0;
  top: auto;
  z-index: 999;
  background: #ffffff;
}
</style>
